import React, { memo, ReactNode, useEffect, useState } from "react";
import { selectionStore } from "../../../stores/selection.store";
import { Moment } from "moment";

import { DayPickerSingleDateController } from "react-dates";
import { capitalize } from "../../../utils";
import { useTranslation } from "react-i18next";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import styled from "styled-components";
import moment from "moment";
import Day from "../day/day";
import { DayStatus } from "../../../types";
import "react-dates/initialize";

import "react-dates/initialize";
import calendarService from "../../../services/calendar-service";
import { getLanguageSwitcherService } from "../../../services/language-switcher.service";

interface GolDayPickerSingleDateProps {
  onDateChange: (momentDate: any) => void;
  calendarDate: Moment;
  numberOfMonths: number;
  onPrevMonth: () => void;
  onNextMonth: () => void;
  hasPrevMonth: boolean;
  hasNextMonth: boolean;
  lastBookingDate: Moment;
  selectedDate: Moment;
}

const ArrowLeft = styled(ArrowBackIosIcon)`
  position: absolute;
  top: 22px;
  left: 10px;
`;

const ArrowRight = styled(ArrowForwardIosIcon)`
  position: absolute;
  top: 22px;
  right: 10px;
`;

const GolDayPickerSingleDateController = (
  props: GolDayPickerSingleDateProps
) => {
  const { t, i18n } = useTranslation();
  const [localeForMoment, setLocaleForMoment] = useState(null);
  useEffect(() => {
    setLocaleForMoment(getLanguageSwitcherService().localeForMoment());
  }, [i18n.language]);

  const renderMonthElement = ({ month }: { month: Moment }) => {
    return capitalize(
      moment(month).locale(localeForMoment).format("MMMM YYYY")
    );
  };

  const getIsDayBlocked = (day: Moment): boolean => {
    return calendarService.isDayBlocked(day);
  };

  const renderDayContents = (currentDate: Moment): ReactNode => {
    return (
      <Day
        day={currentDate}
        status={calendarService.getStatus(currentDate) || DayStatus.unavailable}
        isSelected={
          props.selectedDate && currentDate.isSame(props.selectedDate, "day")
        }
        lastBookingDate={props.lastBookingDate}
      />
    );
  };

  return (
    <DayPickerSingleDateController
      onDateChange={props.onDateChange}
      focused={true}
      onFocusChange={(focused) => focused}
      date={props.calendarDate}
      numberOfMonths={props.numberOfMonths}
      navNext={<ArrowRight data-test="next-month-arrow" />}
      navPrev={<ArrowLeft data-test="prev-month-arrow" />}
      firstDayOfWeek={1}
      initialVisibleMonth={() => selectionStore.calendarDate}
      renderDayContents={renderDayContents}
      isDayBlocked={getIsDayBlocked}
      renderMonthElement={renderMonthElement}
      renderWeekHeaderElement={(day) => capitalize(t(day.toLowerCase()))}
      onPrevMonthClick={props.onPrevMonth}
      onNextMonthClick={props.onNextMonth}
      noNavPrevButton={!props.hasPrevMonth}
      noNavNextButton={!props.hasNextMonth}
      hideKeyboardShortcutsPanel
      daySize={36}
    />
  );
};

export default memo(GolDayPickerSingleDateController);
